import { useEffect, useRef, useState } from 'react';
import { Select, Button, Form, Input, Modal, Space, Tag, Tooltip } from 'antd';
import { useTranslation } from 'react-i18next';
import { PlusOutlined } from '@ant-design/icons';
import classNames from 'classnames';

export default function ModalAddTag({ open, handelClose }) {
    const { t, i18n } = useTranslation();
    const lang = i18n.language;
    const [form] = Form.useForm();
    const [groupList] = useState(mock);
    const [loading] = useState(false);
    const [err, setError] = useState(false);
    const [change, setChange] = useState(false);

    // const { token } = theme.useToken();
    // 'Unremovable', 'Tag 2', 'Tag 3'
    const [tags, setTags] = useState([]);
    const [inputVisible, setInputVisible] = useState(false);
    const [inputValue, setInputValue] = useState('');
    const [editInputIndex, setEditInputIndex] = useState(-1);
    const [editInputValue, setEditInputValue] = useState('');
    const inputRef = useRef(null);
    const editInputRef = useRef(null);
    useEffect(() => {
        if (inputVisible) {
            inputRef.current?.focus();
        }
    }, [inputVisible]);
    useEffect(() => {
        editInputRef.current?.focus();
    }, [inputValue]);
    const handleClose = (removedTag) => {
        const newTags = tags.filter((tag) => tag !== removedTag);
        console.log('newTags ', newTags);
        setTags(newTags);
        form.setFieldsValue({ tagName: newTags });
    };
    const showInput = () => {
        setInputVisible(true);
    };
    const handleInputChange = (e) => {
        setInputValue(e.target.value);
    };
    const handleInputConfirm = () => {
        if (inputValue && tags.indexOf(inputValue) === -1) {
            setTags([...tags, inputValue]);
            form.setFieldsValue({ tagName: [...tags, inputValue] });
        }
        setInputVisible(false);
        setInputValue('');
    };
    const handleEditInputChange = (e) => {
        setEditInputValue(e.target.value);
    };
    const handleEditInputConfirm = () => {
        const newTags = [...tags];
        newTags[editInputIndex] = editInputValue;
        setTags(newTags);
        // setEditInputIndex(-1);
        setInputValue('');
    };

    const onKeyUp = (e) => {
        if (e.target.value) {
            setError(false);
        } else {
            setError(true);
        }
    };

    const tagInputStyle = {
        width: 150,
        verticalAlign: 'top',
        borderColor: '#B1C8DF',
    };
    const tagPlusStyle = {
        background: '#ffffff',
        borderStyle: 'dashed',
        color: '#1890FF',
        borderWidth: '1px',
        borderColor: '#1890FF',
        width: '130px',
        padding: '1px 6px',
    };

    const onFinish = async (e) => {
        console.log(e);
        setChange(true);
        handelClose();
    };

    const onFinishFailed = async (e) => {
        console.log(e);
        setChange(true);
    };

    useEffect(() => {
        if (change === true) {
            if (tags && tags?.length === 0) {
                setError(true);
                form.setFields([
                    {
                        name: 'tagName',
                        errors: [
                            lang === 'en'
                                ? 'This field is required.'
                                : 'กรุณากรอกข้อมูลให้ครบถ้วน',
                        ],
                    },
                ]);
            } else {
                setError(false);
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [tags, change]);

    return (
        <Modal
            width={680}
            afterClose={() => {
                form.resetFields();
                setEditInputValue();
                setTags([]);
                setError(false);
                setChange(false);
                // setDomainId()
            }}
            bodyStyle={{ padding: '60px' }}
            className="_modal"
            footer={false}
            open={open}
            closable={true}
            onCancel={() => {
                form.resetFields();
                setEditInputValue();
                setTags([]);
                setError(false);
                setChange(false);
                handelClose();
            }}
        >
            <div className="px-8 py-4 pt-2 pb-8">
                <div className="text-2xl font-base pb-12 text-center">
                    Add Tag/Data
                </div>
                <Form
                    scrollToFirstError={{
                        behavior: 'smooth',
                        block: 'center',
                    }}
                    form={form}
                    layout="vertical"
                    onFinish={onFinish}
                    onFinishFailed={onFinishFailed}
                >
                    <Form.Item
                        name="groupId"
                        label={t('Group')}
                        rules={[
                            {
                                required: true,
                                message: t('errorText.requiredField'),
                            },
                        ]}
                    >
                        <Select
                            size="large"
                            onChange={(e) => {
                                console.log(e);
                            }}
                            placeholder={t('Select Group')}
                        >
                            {groupList.map((e) => {
                                return (
                                    <Select key={e.id} value={e.id}>
                                        {e.value}
                                    </Select>
                                );
                            })}
                        </Select>
                    </Form.Item>

                    <Form.Item
                        name="tagName"
                        label={t('Tag Name')}
                        rules={[
                            {
                                required: true,
                                message: t('errorText.requiredField'),
                            },
                        ]}
                    >
                        <div
                            className={`
                            ${classNames(
                                'border-[#ECECEC] bg-white rounded-md whitespace-pre-line border-solid border p-3 mt-2 leading-7 overflow-auto max-h-[200px] min-h-[200px] ',
                                {
                                    'border-[#F0536F]': err === true,
                                }
                            )}`}
                        >
                            <Space size={[0, 8]} wrap>
                                <Space size={[0, 8]} wrap>
                                    {tags.map((tag, index) => {
                                        if (editInputIndex === index) {
                                            return (
                                                <Input
                                                    ref={editInputRef}
                                                    key={tag}
                                                    size="small"
                                                    style={tagInputStyle}
                                                    value={editInputValue}
                                                    onChange={
                                                        handleEditInputChange
                                                    }
                                                    onBlur={
                                                        handleEditInputConfirm
                                                    }
                                                    onPressEnter={
                                                        handleEditInputConfirm
                                                    }
                                                />
                                            );
                                        }
                                        const isLongTag = tag.length > 20;
                                        const tagElem = (
                                            <Tag
                                                key={tag}
                                                closable={true}
                                                style={{
                                                    userSelect: 'none',
                                                    borderColor: '#B1C8DF',
                                                    color: '#65707A',
                                                    padding: '1px 6px',
                                                }}
                                                onClose={() => handleClose(tag)}
                                            >
                                                <span
                                                    onDoubleClick={(e) => {
                                                        setEditInputIndex(
                                                            index
                                                        );
                                                        setEditInputValue(tag);
                                                        e.preventDefault();
                                                    }}
                                                >
                                                    {isLongTag
                                                        ? `${tag.slice(
                                                              0,
                                                              20
                                                          )}...`
                                                        : tag}
                                                </span>
                                            </Tag>
                                        );
                                        return isLongTag ? (
                                            <Tooltip title={tag} key={tag}>
                                                {tagElem}
                                            </Tooltip>
                                        ) : (
                                            tagElem
                                        );
                                    })}
                                </Space>
                                {inputVisible ? (
                                    <Input
                                        ref={inputRef}
                                        type="text"
                                        size="small"
                                        style={tagInputStyle}
                                        value={inputValue}
                                        onChange={handleInputChange}
                                        onBlur={handleInputConfirm}
                                        onPressEnter={handleInputConfirm}
                                        onKeyUp={onKeyUp}
                                    />
                                ) : (
                                    <Tag
                                        style={tagPlusStyle}
                                        onClick={showInput}
                                    >
                                        <PlusOutlined /> Add Tag Name
                                    </Tag>
                                )}
                            </Space>{' '}
                        </div>
                    </Form.Item>
                    <div className="flex justify-center items-center space-x-4 pt-4">
                        <Button
                            className="min-w-[150px]"
                            type="primary"
                            onClick={handelClose}
                            size="large"
                            ghost
                        >
                            {t('common.Cancel')}
                        </Button>

                        <Button
                            className="min-w-[150px]"
                            loading={loading}
                            size="large"
                            type="primary"
                            htmlType="submit"
                        >
                            {t('common.Submit')}
                        </Button>
                    </div>
                </Form>
            </div>
        </Modal>
    );
}

const mock = [
    {
        id: 111,
        value: 'Personal Data',
    },
    {
        id: 112,
        value: 'Sensitive Data',
    },
];
